"use client"

import { useNavigate } from "react-router-dom"
import Icon from "../components/Icon"

function LockedPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-rose-50 flex items-center justify-center p-6 font-sans">
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/40 max-w-md w-full p-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-red-500 to-rose-600 rounded-2xl mb-4">
          <Icon name="lock" size="2rem" className="text-white" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Account Locked</h1>
        <p className="text-gray-600 text-sm mb-6">
          Your profile has been locked by an administrator. You cannot access the system until it is unlocked.
        </p>
        <div className="space-y-2 text-sm text-gray-700">
          <p>Please contact your administrator for assistance.</p>
        </div>
        <button
          onClick={() => {
            localStorage.removeItem('token')
            navigate('/login')
          }}
          className="mt-6 w-full bg-gray-800 text-white py-2.5 rounded-lg hover:bg-gray-900 transition-colors"
        >
          Back to Login
        </button>
      </div>
    </div>
  )
}

export default LockedPage


